import apiFetch from '../../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Intervencion/obtenerNumeroRegistroIntervencionSanitaria`, method: 'GET', body: null, token: token})
}